function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "store",
  transform: "translate(-425 -361.809)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  width: 23,
  height: 18,
  transform: "translate(425 368)",
  fill: "#1f1f1f"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 4,
  height: 4,
  transform: "translate(432 373)",
  fill: "#f25022"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  width: 4,
  height: 4,
  transform: "translate(437 373)",
  fill: "#7fba00"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  width: 4,
  height: 4,
  transform: "translate(432 378)",
  fill: "#00a4ef"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  width: 4,
  height: 4,
  transform: "translate(437 378)",
  fill: "#ffb900"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M430.921,368.167V363.74a1.565,1.565,0,0,1,1.579-1.2c1.3.038,8.548,0,8.548,0s1,.075,1.03,1.613,0,4.015,0,4.015",
  transform: "translate(0 0.521)",
  fill: "none",
  stroke: "#1f1f1f",
  strokeWidth: 2.5
}));

function SvgStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24.191,
    viewBox: "0 0 23 24.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.d38292c1.svg";
export { ForwardRef as ReactComponent };